import { connect } from 'react-redux'
import {
  compose,
  withState,
  withHandlers,
  branch,
  renderComponent
} from 'recompose'
import { withTranslation } from 'react-i18next'
import {
  userIdSelector,
  anonSelector
} from '../../../store/selectors/baseSelectors'
import {
  createThread,
  replyComment,
  selectThread,
  cancelNewThread
} from '../../../store/actions/discuss'
import { withShortcuts } from '../../../containers/Shortcuts'
import { SigninToComment } from './CommentForm'

const CommentFormContianer = compose(
  connect(
    state => ({
      anon: anonSelector(state),
      userId: userIdSelector(state)
    }),
    { createThread, replyComment, cancelNewThread, selectThread }
  ),
  withTranslation(),
  branch(({ anon }) => anon, renderComponent(SigninToComment)),
  withState('text', 'setText', ''),
  withHandlers({
    post: ({ replyComment, createThread, text, setText, thread }) => () => {
      if (!text) return
      setText('')
      if (thread.new) createThread(text)
      else replyComment(thread, text)
    },
    cancel: ({ setText, selectThread, cancelNewThread, thread }) => () => {
      setText('')
      if (!thread.new) cancelNewThread()
      else selectThread(null)
    }
  }),
  withShortcuts('DISCUSS', ({ post, cancel }) => (action, event) => {
    switch (action) {
      case 'POST_COMMENT':
        post()
        event.preventDefault()
        break
      case 'CANCEL_COMMENT':
        cancel()
        event.preventDefault()
        break
      default:
    }
  })
)

export default CommentFormContianer
